module.exports = __webpack_public_path__ + "static/media/main_logo.00abe413.svg";